<template>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '420px' }"
    :header="data_recurso.id ? 'EDITAR MENÚ' : 'NUEVO MENÚ'"
    :modal="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12">
          <strong>NOMBRE: </strong><span class="p-invalid">*</span>
          <InputText v-model.trim="data_recurso.nombre" placeholder="Ej: Menú 1, Menú Norte..." autofocus />
          <small class="p-invalid" v-if="errors.nombre">{{ errors.nombre[0] }}</small>
        </div>

        <div class="field col-12 md:col-6">
          <strong>COLOR DE FONDO: </strong>
          <div class="flex align-items-center gap-2 mt-1">
            <input
              type="color"
              v-model="data_recurso.color"
              style="
                width: 44px;
                height: 36px;
                border: 1px solid #dee2e6;
                border-radius: 6px;
                cursor: pointer;
                padding: 2px;
              "
            />
            <InputText v-model.trim="data_recurso.color" placeholder="#007dd7" class="w-full" maxlength="7" />
          </div>
          <small class="p-invalid" v-if="errors.color">{{ errors.color[0] }}</small>
        </div>

        <div class="field col-12 md:col-6">
          <strong>COLOR DE TEXTO: </strong>
          <div class="flex align-items-center gap-2 mt-1">
            <input
              type="color"
              v-model="data_recurso.text_color"
              style="
                width: 44px;
                height: 36px;
                border: 1px solid #dee2e6;
                border-radius: 6px;
                cursor: pointer;
                padding: 2px;
              "
            />
            <InputText v-model.trim="data_recurso.text_color" placeholder="#ffffff" class="w-full" maxlength="7" />
          </div>
          <small class="p-invalid" v-if="errors.text_color">{{ errors.text_color[0] }}</small>
        </div>

        <div class="field col-12">
          <strong>VISTA PREVIA: </strong>
          <div
            class="mt-1 flex align-items-center justify-content-center"
            :style="{
              background: data_recurso.color || '#007dd7',
              color: data_recurso.text_color || '#ffffff',
              padding: '10px 20px',
              borderRadius: '8px',
              fontWeight: '700',
              fontSize: '14px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              minHeight: '40px'
            }"
          >
            {{ data_recurso.nombre || 'Nombre del menú' }}
          </div>
        </div>

        <div class="field col-12 md:col-6" v-if="data_recurso.id">
          <strong>ESTADO: </strong><span class="p-invalid">*</span>
          <Dropdown
            v-model="data_recurso.estado"
            :options="estados"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccione..."
          >
            <template #value="slotProps">
              <span :class="'product-badge ' + claseEstado[slotProps.value]">
                {{ slotProps.value === 1 ? 'ACTIVO' : 'INACTIVO' }}
              </span>
            </template>
          </Dropdown>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="field">
        <label class="flex md:justify-content-start">
          <strong>CAMPOS REQUERIDOS: </strong><span class="p-invalid">*</span>
        </label>
      </div>
      <Button
        label="CANCELAR"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="ocultarDialog"
        :disabled="enviado"
      />
      <Button
        :label="data_recurso.id ? 'ACTUALIZAR' : 'GUARDAR'"
        icon="pi pi-save"
        class="p-button-primary p-button-lg"
        @click="guardar"
        :loading="enviado"
        :disabled="enviado"
      />
    </template>
  </Dialog>
</template>

<script>
import RecursoService from '@/service/RecursoService'

export default {
  emits: ['closeModal', 'actualizarListado'],

  props: {
    show: { type: Boolean, default: false },
    recurso: { type: Object, default: () => ({}) }
  },

  data() {
    return {
      mostrarModal: this.show,
      data_recurso: { ...this.recurso },
      enviado: false,
      errors: {},
      estados: [
        { label: 'ACTIVO', value: 1 },
        { label: 'INACTIVO', value: 0 }
      ],
      claseEstado: ['status-outofstock', 'status-instock']
    }
  },

  recursoService: null,

  created() {
    this.recursoService = new RecursoService()
  },

  methods: {
    ocultarDialog() {
      this.errors = {}
      this.enviado = false
      this.mostrarModal = false
      this.$emit('closeModal')
    },

    guardar() {
      this.errors = {}
      this.enviado = true

      if (this.data_recurso.id) {
        this.recursoService.update(this.data_recurso.id, this.data_recurso).then((res) => {
          if (res.errors) {
            this.errors = res.errors
            this.enviado = false
          } else {
            this.$toast.add({ severity: 'success', summary: 'Éxito', detail: res.mensaje, life: 3000 })
            this.$emit('actualizarListado')
            this.ocultarDialog()
            this.enviado = false
          }
        })
      } else {
        this.recursoService.create(this.data_recurso).then((res) => {
          if (res.errors) {
            this.errors = res.errors
            this.enviado = false
          } else {
            this.$toast.add({ severity: 'success', summary: 'Éxito', detail: res.mensaje, life: 3000 })
            this.$emit('actualizarListado')
            this.ocultarDialog()
            this.enviado = false
          }
        })
      }
    }
  },

  watch: {
    show(v) {
      this.mostrarModal = v
    },
    recurso(v) {
      this.data_recurso = { ...v }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';
.p-invalid {
  color: red;
}
</style>